export default __webpack_public_path__ + "static/media/scrum-study-cards-hero.eeb5906f.png";